// extracted by mini-css-extract-plugin
export const content = "blog-module--content--SZQKq";
export const posts = "blog-module--posts--30wiP";
export const tagLink = "blog-module--tagLink--1ohSY";
export const post = "blog-module--post--2DjrZ";